import { render } from "./CharacterSheet.vue?vue&type=template&id=70d9805d&scoped=true&ts=true"
import script from "./CharacterSheet.vue?vue&type=script&lang=ts"
export * from "./CharacterSheet.vue?vue&type=script&lang=ts"

import "./CharacterSheet.vue?vue&type=style&index=0&id=70d9805d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d9805d"]])

export default __exports__